module.exports = __webpack_public_path__ + "static/media/  (19).a3c62124.jpg";